
import React, { useState } from 'react';
import { FiPlus, FiMinus } from 'react-icons/fi'; // Iconos de react-icons
import '../../css/TerminosDelSorteo.css'

import {CONSTANTES} from "../../config/constantaes";

const TerminosDelSorteo = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => setIsOpen(!isOpen);

  
 return (
    <div className='content-modal'>
      <div onClick={toggleAccordion} className='content-modal-titulo'>
        <strong className='titulo-term'>Términos del sorteo</strong>
        {isOpen ? <FiMinus color="#f44336" /> : <FiPlus color="#f44336" />}
      </div>

      <div className="context-modal">
          {isOpen && (
            <p>
              Términos y condiciones de &quot;Los Premiazos de Alfin&quot;. Vigencia: del
              15/08/2026 al 15/10/2026. Requisitos: Para participar, el usuario deberá
              registrarse por primera vez en{" "}
              <a
                href="https://prestamos.alfinbanco.pe"
                target="_blank"
                rel="noopener noreferrer"
              >
                prestamos.alfinbanco.pe
              </a>
              ,{" "}
              <a
                href="https://alfincontacto.com.pe"
                target="_blank"
                rel="noopener noreferrer"
              >
                alfincontacto.com.pe
              </a>
              , WhatsApp 946 570 669 o mediante la apertura de la Cuenta Digital
              &quot;Ahorro Meta&quot;, y otorgar el Consentimiento para el Tratamiento de
              Datos Personales con Finalidades Comerciales. Para el canal de Ahorro Meta,
              deberá mantener un monto mínimo de S/1,000 durante la vigencia de la
              campaña. El consentimiento deberá permanecer vigente hasta la entrega del
              premio. Los participantes no deberán mantener créditos vencidos, castigados,
              refinanciados, reprogramados o en proceso judicial con Alfin Banco S.A.
              Mecánica de participación: (1) Quienes se registren y otorguen su
              consentimiento participarán por un (1) TV Smart Nium de 60&quot;. (2)
              Quienes, además, contraten y desembolsen un crédito Prestaltoke o
              Credialtoque participarán por S/1,000 en efectivo. Sorteos: 11/09/2026 y
              16/10/2026. Premios: dos (2) premios de S/1,000 en efectivo y dos (2) TV
              Smart Nium de 60&quot;. Imágenes referenciales y premios sujetos a
              disponibilidad de stock. Más información en{" "}
              <a href="https://alfinbanco.pe/comunicados"
                target="_blank"
                rel="noopener noreferrer"
              > www.alfinbanco.pe/comunicados </a>
              .
            </p>
          )}
      </div>
    </div>
 );
};

export default TerminosDelSorteo;